module.exports = __webpack_public_path__ + "static/media/Thanda Island triumphs.4ad510a5.jpg";